/* GOOD GAME Lorcana: listing defaults for links, including links opened in new tabs.
 * Adds <group param>=<first value> (window.GGListingConfig, emitted by layout/theme.liquid from
 * snippets/gg-group-config.liquid) to same-site collection links. Collection links get NO sort_by
 * (2026-10-16, family-order rollout): the collection's own sort order (manual pair order, or its
 * default such as PRICE_DESC) applies within each stock group. /search?q= links also get
 * sort_by=<default sort> when it is missing (search cannot be manual-sorted).
 * No redirect and no reload: the current page is never changed by this script.
 * Not touched: /collections/all, pagination, facet links, and links marked [data-gg-raw]
 * (for example the "すべて表示" link, which intentionally has no group param).
 * Franchise collections (/collections/franchise-*, template collection.franchise) are not grouped:
 * their links keep the previous default filter.v.availability=1 (+ sort_by), exactly as before.
 * Search forms (snippets/search-card.liquid) and custom.js add the same defaults themselves;
 * /search?q= links are normalized here too. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var config = window.GGListingConfig || {};
  var groupParam = config.groupParam;
  var groupValue = config.groupFirstValue;
  var defaultSort = config.defaultSort || 'price-descending';
  function normalizeUrl(href) {
    if (!href || href.charAt(0) === '#') return href;
    var page = new URL(window.location.href);
    var target;
    try { target = new URL(href, page); } catch (_) { return href; }
    if (target.origin !== page.origin || /\/collections\/all(\/.*)?$/.test(target.pathname)) return href;
    var franchise = false;
    var collection = /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(target.pathname) &&
      !/\/collections\/[^/]+\/products\/?$/.test(target.pathname);
    var search = /\/search\/?$/.test(target.pathname) && target.searchParams.get('q');
    if (!collection && !search) return href;
    if (collection && /\/collections\/franchise-[^/]*/.test(target.pathname)) {
      // Franchise pages keep their own in-stock toggle (filter.v.availability) and sort_by default (unchanged).
      franchise = true;
      if (!target.searchParams.has('filter.v.availability')) target.searchParams.set('filter.v.availability', '1');
    } else if (groupParam && groupValue && !target.searchParams.has(groupParam)) {
      target.searchParams.set(groupParam, groupValue);
    }
    if ((search || franchise) && !target.searchParams.get('sort_by')) target.searchParams.set('sort_by', defaultSort);
    return target.pathname + target.search + target.hash;
  }
  window.GGListingNavigation = { normalizeUrl: normalizeUrl };
  function prepareLink(link) {
    // Filter removals and pagination carry their own server-built state.
    if (!link || link.hasAttribute('data-gg-raw') ||
        link.closest('facet-remove, facet-filters-form, .pagination, .active-facets, .gg-group-notice')) return;
    var before = link.getAttribute('href');
    var after = normalizeUrl(before);
    if (after !== before) link.setAttribute('href', after);
  }
  document.querySelectorAll('a[href]').forEach(prepareLink);
  ['pointerdown', 'focusin', 'click', 'contextmenu'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      prepareLink(event.target.closest && event.target.closest('a[href]'));
    }, true);
  });
})();
